import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { STATUS } from '../utils/status';
import { fetchCorporate } from './../redux/corporateSlice';
import Loader from '../components/Loader';
import { toast } from 'react-toastify';

const CorporatePage = () => {
    const dispatch = useDispatch();
    const { corporatedata, corporatestatus, corporateerror } = useSelector((state) => state.corporate);

    useEffect(() => {
        if (corporatestatus === STATUS.IDLE) {
            dispatch(fetchCorporate());
        }
    }, [corporatestatus, dispatch]);

    // Yüklenme durumunu kontrol etme
    if (corporatestatus === STATUS.LOADING) {
        return <div className="h-[40vh] flex items-center">  <Loader />    </div>
    }

    // Hata durumunu kontrol etme
    if (corporatestatus === STATUS.FAIL) {
        return <div className="text-center mt-4">Error: {toast.error(corporateerror)}</div>;
    }

    // Veri boşsa kontrol etme
    if (!corporatedata || corporatedata.length === 0) {
        return <div className="text-center mt-4">No location data available</div>;
    }

    // Konum verisi mevcutsa bileşeni render etme
    const { degerler, hedefler, kalitepolitikasi, misyon, vizyon } = corporatedata[0];
    return (
        <div className="mx-auto bg-white p-8 shadow-md rounded-md">
            <div className="mx-auto bg-white p-8 shadow-md rounded-md container mt-10">
                <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl xl:text-3xl 2xl:text-3xl 3xl:text-3xl  font-bold mb-6">Kurumsal Bilgiler</h1>
                <div className="mb-4">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl  font-bold mb-2">Misyon</h2>
                    <p className="text-gray-700">{misyon}</p>
                </div>
                <div className="mb-4">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl font-bold mb-2">Vizyon</h2>
                    <p className="text-gray-700">{vizyon}</p>
                </div>
                <div className="mb-4">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl font-bold mb-2">Değerler</h2>
                    <ul className="list-disc list-inside text-gray-700">
                        {degerler.map((data, ind) => (<li key={ind}>{data}</li>))}
                    </ul>
                </div>
                <div className="mb-4">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl font-bold mb-2">Hedefler</h2>
                    <ul className="list-disc list-inside text-gray-700">
                        {hedefler.map((data, ind) => (<li key={ind}>{data}</li>))}
                    </ul>
                </div>

                <div className="mb-4">
                    <h2 className="text-lg sm:text-xl md:text-2xl lg:text-2xl xl:text-2xl 2xl:text-2xl 3xl:text-2xl font-bold mb-2">Kalite Politikası</h2>
                    <p className="text-gray-700">{kalitepolitikasi}</p>
                </div>

            </div>
        </div>
    );
}

export default CorporatePage
